export class SampleManagement {
    id = null;
    name = null;
    code = null;
}